(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var NOTE_FLAG = 'cart-bundle-removed';

    /* Show the "bundle removed" note after the post-removal reload. */
    var note = document.getElementById('cart-bundle-note');
    if (note && sessionStorage.getItem(NOTE_FLAG)) {
      sessionStorage.removeItem(NOTE_FLAG);
      note.hidden = false;
    }

    var form = document.getElementById('cart-page-form');
    if (!form) return;

    /* Quantities post to /cart/update.js keyed by line key (inputs carry
       data-line-key) instead of form updates[] fields, so bundle grouping
       is free to reorder lines without breaking updates. Bundled lines
       render no input and are therefore never touched. */
    function submitQuantities() {
      var updates = {};
      form.querySelectorAll('[data-qty-input]').forEach(function(input) {
        updates[input.dataset.lineKey] = Math.max(0, parseInt(input.value, 10) || 0);
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).finally(function() {
        window.location.reload();
      });
    }

    form.addEventListener('click', function(e) {
      var minusBtn = e.target.closest('[data-qty-minus]');
      var plusBtn  = e.target.closest('[data-qty-plus]');
      if (!minusBtn && !plusBtn) return;

      e.preventDefault();
      var item  = e.target.closest('.cart-item');
      var input = item.querySelector('[data-qty-input]');
      var val   = parseInt(input.value, 10) || 0;

      if (minusBtn) {
        input.value = Math.max(0, val - 1);
      } else {
        input.value = val + 1;
      }

      submitQuantities();
    });

    /* "Update" button / Enter in a quantity field: route through
       /cart/update.js too. The checkout button keeps its native submit. */
    form.addEventListener('submit', function(e) {
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      submitQuantities();
    });

    /* Bundle cascade removal: lines added together (pattern + yarn) share a
       _bundle_id property, rendered as data-bundle-id. The default remove
       link only drops one line, so intercept it, confirm via the global
       bundle modal, then zero every line of the bundle in a single
       /cart/update.js call and reload. */
    form.addEventListener('click', function(e) {
      var removeLink = e.target.closest('.cart-item__remove');
      if (!removeLink) return;

      var item = e.target.closest('.cart-item');
      var bundleId = item && item.dataset.bundleId;
      if (!bundleId) return; /* not bundled: let the default link navigate */

      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:confirm-bundle-removal', {
        detail: {
          onConfirm: function() {
            var updates = {};
            form.querySelectorAll('.cart-item').forEach(function(el) {
              if (el.dataset.bundleId === bundleId) updates[el.dataset.itemKey] = 0;
            });

            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            })
              .then(function() {
                sessionStorage.setItem(NOTE_FLAG, '1');
              })
              .finally(function() {
                window.location.reload();
              });
          }
        }
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.getElementById('site-header');
    if (!header) return;

    const bar = document.getElementById('announcement-bar');

    function setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }

    /* Keep the fixed header just below the visible announcement bar */
    function syncHeaderTop() {
      var barBottom = (bar && !bar.hidden) ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
      header.style.top = barBottom + 'px';
    }

    var lastScrollY = window.scrollY;

    function updateScrollState() {
      var isHomePage = document.body.dataset.template === 'index';
      var isMobile = window.innerWidth < 768;
      var threshold = (isHomePage && isMobile) ? 40 : 12;
      header.classList.toggle('is-scrolled', window.scrollY > threshold);

      if (isMobile) {
        var currentY = window.scrollY;
        var scrollingDown = currentY > lastScrollY;
        if (scrollingDown && currentY > 80) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
        lastScrollY = currentY;
      } else {
        header.classList.remove('is-hidden');
      }

      document.body.classList.toggle('header-hidden', header.classList.contains('is-hidden'));
    }

    function onFrame() {
      syncHeaderTop();
      updateScrollState();
    }

    setHeaderHeight();
    syncHeaderTop();
    updateScrollState();

    window.addEventListener('scroll', onFrame, { passive: true });
    window.addEventListener('resize', function () {
      setHeaderHeight();
      syncHeaderTop();
    }, { passive: true });

    const closeBtn = document.querySelector('[data-announcement-close]');
    if (closeBtn && bar) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        syncHeaderTop();
      });
    }

    /* ── Mobile nav ────────────────────────────────────── */
    var mobileNav = document.getElementById('mobile-nav');
    var menuToggle = document.querySelector('[data-menu-toggle]');

    if (mobileNav && menuToggle) {
      var closedByKeyboard = false;

      function openMenu() {
        mobileNav.classList.add('is-open');
        mobileNav.removeAttribute('inert');
        mobileNav.setAttribute('aria-hidden', 'false');
        menuToggle.setAttribute('aria-expanded', 'true');
        var backdrop = mobileNav.querySelector('[data-drawer-backdrop]');
        if (backdrop) backdrop.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }

      // Close is delegated to drawer-js (close button, backdrop, Escape).
      // Listen for the 'drawer:close' event to sync toggle button state.
      mobileNav.addEventListener('drawer:close', function () {
        mobileNav.setAttribute('inert', '');
        mobileNav.setAttribute('aria-hidden', 'true');
        menuToggle.setAttribute('aria-expanded', 'false');
        // Only return focus for keyboard users — pointer focus triggers
        // Safari's blue focus ring.
        if (closedByKeyboard) menuToggle.focus();
        closedByKeyboard = false;
      });

      // Track keyboard-initiated closes so we can restore focus.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
          closedByKeyboard = true;
        }
      });

      menuToggle.addEventListener('click', function () {
        if (mobileNav.classList.contains('is-open')) {
          // Trigger close via the shared drawer-js by dispatching a close event
          // manually, keeping aria/inert state in sync via the drawer:close listener.
          mobileNav.classList.remove('is-open');
          var backdrop = mobileNav.querySelector('[data-drawer-backdrop]');
          if (backdrop) backdrop.classList.remove('is-visible');
          document.body.style.overflow = '';
          mobileNav.setAttribute('inert', '');
          mobileNav.setAttribute('aria-hidden', 'true');
          menuToggle.setAttribute('aria-expanded', 'false');
        } else {
          openMenu();
        }
      });

      mobileNav.querySelectorAll('.mobile-nav__link').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileNav.classList.remove('is-open');
          var backdrop = mobileNav.querySelector('[data-drawer-backdrop]');
          if (backdrop) backdrop.classList.remove('is-visible');
          document.body.style.overflow = '';
          mobileNav.setAttribute('inert', '');
          mobileNav.setAttribute('aria-hidden', 'true');
          menuToggle.setAttribute('aria-expanded', 'false');
        });
      });
    }

    /* ── Inline search ──────────────────────────────────── */
    var searchInline = document.getElementById('search-inline');
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchInput = searchInline && searchInline.querySelector('.search-inline__input');
    var searchClose = searchInline && searchInline.querySelector('[data-search-close]');

    if (searchInline && searchToggle) {
      function openSearch() {
        header.classList.add('is-search-open');
        searchInline.removeAttribute('inert');
        searchInline.setAttribute('aria-hidden', 'false');
        searchToggle.setAttribute('aria-expanded', 'true');
        setTimeout(function () {
          if (searchInput) searchInput.focus();
        }, 50);
      }

      function closeSearch() {
        header.classList.remove('is-search-open');
        searchInline.setAttribute('inert', '');
        searchInline.setAttribute('aria-hidden', 'true');
        searchToggle.setAttribute('aria-expanded', 'false');
      }

      searchToggle.addEventListener('click', function () {
        if (header.classList.contains('is-search-open')) {
          closeSearch();
        } else {
          openSearch();
        }
      });

      if (searchClose) {
        searchClose.addEventListener('click', function () {
          closeSearch();
          searchToggle.focus();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && header.classList.contains('is-search-open')) {
          closeSearch();
          searchToggle.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (
          header.classList.contains('is-search-open') &&
          !searchInline.contains(e.target) &&
          !searchToggle.contains(e.target)
        ) {
          closeSearch();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pattern"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[id^="pattern-yarn-json-"]').forEach(function (yarnDataEl) {
      var sid = yarnDataEl.id.replace('pattern-yarn-json-', '');
      initPatternPage(sid, yarnDataEl);
    });

    function initPatternPage(sid, yarnDataEl) {
    var i18nEl = document.getElementById('pattern-i18n-' + sid);
    var container = document.getElementById('product-' + sid);
    if (!i18nEl || !container) return;

    var patternData = JSON.parse(yarnDataEl.textContent);
    var i18n = i18nEl.dataset;

    // The yarn amounts are keyed by the Swedish size name ("4 år"), but on the English
    // site the variant's size reads "4 years". custom.variant_sizes (written by
    // pattern:import) gives the Swedish name per variant; fall back to the shown name.
    var variantSizes = patternData.variant_sizes || {};
    function sizeKey(variant) {
      return variantSizes[String(variant.id)] || (variant.options && variant.options[0]);
    }
    var yarnRequired = patternData.yarn_required;

    // Card roles come from custom.yarn_for_pattern, which is never translated (it
    // holds variant IDs), so they are always Swedish: a base word plus an optional
    // suffix ("Mönsterfärg 2", "Färg A"). Translate the base word, keep the suffix,
    // and show anything unrecognised as written.
    var ROLE_KEYS = { 'Bottenfärg': 'roleMain', 'Mönsterfärg': 'rolePattern', 'Kontrastfärg': 'roleContrast', 'Färg': 'roleColour', 'Garn': 'roleYarn' };
    function roleLabel(role) {
      var match = role.match(/^(\S+)(\s+.*)?$/);
      var key = match && ROLE_KEYS[match[1]];
      return key && i18n[key] ? i18n[key] + (match[2] || '') : role;
    }

    // Pattern variant prices (cents), keyed by variant id, for the bundle total.
    var patternVariants = {};
    var patternProductEl = document.getElementById('product-json-' + sid);
    if (patternProductEl) {
      try {
        JSON.parse(patternProductEl.textContent).variants.forEach(function (v) {
          patternVariants[v.id] = v.price;
        });
      } catch (e) { /* leave prices empty; total falls back to yarns only */ }
    }

    // Same money format template product-form puts on its ATC button
    // (shop.money_with_currency_format), so bundle prices follow the store's
    // format and the active currency instead of a hardcoded "… SEK".
    var moneyFormatEl = document.getElementById('add-to-cart-' + sid);
    var moneyFormat = (moneyFormatEl && moneyFormatEl.dataset.moneyFormat) || '';
    var MONEY_STYLES = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', '']
    };

    function formatMoney(cents) {
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      // Template should always be present; degrade to a grouped integer (no
      // hardcoded currency) if it is ever missing, like product-form does.
      if (!match) return Math.round(cents / 100).toLocaleString();
      var style = MONEY_STYLES[match[1]] || MONEY_STYLES.amount;
      var parts = (cents / 100).toFixed(style[0]).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + style[1]);
      return moneyFormat.replace(match[0], whole + (parts[1] ? style[2] + parts[1] : ''));
    }

    // Price of the currently selected pattern variant (size), in cents.
    function getPatternPrice() {
      var variantInput = document.getElementById('variant-id-' + sid);
      if (!variantInput || !variantInput.value) return 0;
      return patternVariants[variantInput.value] || 0;
    }

    // Build the bundle line items (pattern + each included yarn picker that has
    // a colour selected) so both the summary and the total share one source.
    function buildSummaryLines() {
      var lines = [{ label: i18n.summaryPattern || '', price: getPatternPrice(), isPattern: true }];
      yarnPickers.forEach(function (p) {
        if (!p.included || p.selectedVariantId == null) return;
        var v = p.variants.find(function (vv) { return vv.id === p.selectedVariantId; });
        if (!v) return;
        lines.push({ label: p.title, qty: p.quantity, price: v.price * p.quantity });
      });
      return lines;
    }

    function computeBundleTotal() {
      return buildSummaryLines().reduce(function (sum, line) { return sum + line.price; }, 0);
    }

    // Render the pattern + yarn breakdown above the ATC and mirror the total on
    // the button. The main product price (top) is left untouched.
    function updateTotalPrice(hasVariant) {
      var summary = document.getElementById('pattern-summary-' + sid);
      if (summary) {
        if (!hasVariant) {
          summary.hidden = true;
          summary.innerHTML = '';
        } else {
          var lines = buildSummaryLines();
          var rowsHtml = lines.map(function (line) {
            var qtyHtml = line.qty
              ? ' <span class="pattern-summary__qty">×' + line.qty + '</span>'
              : '';
            return '<div class="pattern-summary__row">'
              + '<span class="pattern-summary__label">' + escHtml(line.label) + qtyHtml + '</span>'
              + '<span class="pattern-summary__price">'
              + (line.isPattern && line.price === 0 && i18n.summaryFree ? escHtml(i18n.summaryFree) : formatMoney(line.price))
              + '</span>'
              + '</div>';
          }).join('');
          var total = lines.reduce(function (s, l) { return s + l.price; }, 0);
          summary.innerHTML = rowsHtml
            + '<div class="pattern-summary__row pattern-summary__row--total">'
            + '<span class="pattern-summary__label">' + escHtml(i18n.summaryTotal || '') + '</span>'
            + '<span class="pattern-summary__price">' + formatMoney(total) + '</span>'
            + '</div>';
          summary.hidden = false;
        }
      }

      var priceEl = document.getElementById('pattern-atc-price-' + sid);
      if (priceEl) priceEl.textContent = formatMoney(computeBundleTotal());
    }

    // Colorway versions. Single-version patterns have one entry; the selector
    // is only rendered when there is more than one.
    var versions = patternData.versions || [];
    var activeVersion = versions[0] || { sizes: {} };
    var currentSizeName = null;

    // yarn pickers state: [{handle, title, url, role, quantity, variants, selectedVariantId, included}]
    var yarnPickers = [];

    // Snapshot of yarnPickers per version.id, saved right before leaving a
    // version. Lets a customer's custom colorway choices survive a round trip
    // through another version instead of being lost on every switch.
    var versionPickerCache = {};

    function escHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    // ── Bundle button state ──────────────────────────────────────────────────
    function updateBundleButton() {
      var btn = document.getElementById('pattern-atc-' + sid);
      var label = document.getElementById('pattern-atc-label-' + sid);
      var priceEl = document.getElementById('pattern-atc-price-' + sid);
      if (!btn || !label) return;

      var variantInput = document.getElementById('variant-id-' + sid);
      var hasVariant = variantInput && variantInput.value && variantInput.value !== '0';

      // Keep the summary and button price in sync with the selection.
      updateTotalPrice(hasVariant);
      if (priceEl) priceEl.hidden = !hasVariant;

      if (!hasVariant) {
        btn.disabled = true;
        label.textContent = i18n.chooseSizeFirst || '';
        return;
      }

      if (!yarnPickers.length) {
        // Size selected but no yarn data for this size
        btn.disabled = true;
        label.textContent = i18n.chooseColors || '';
        return;
      }

      var allReady = yarnPickers.every(function (p) {
        if (!p.included) return true;
        return p.selectedVariantId !== null;
      });

      btn.disabled = !allReady;
      label.textContent = allReady
        ? (i18n.addBundle || '')
        : (i18n.chooseColors || '');
    }

    // ── Colorway version selector ────────────────────────────────────────────
    function renderVersionSelector() {
      var host = document.getElementById('pattern-version-selector-' + sid);
      if (!host) return;
      if (versions.length < 2) {
        host.hidden = true;
        return;
      }
      host.hidden = false;

      var optionsHtml = versions.map(function (v, idx) {
        var isActive = (v.id === activeVersion.id);
        return '<button type="button" class="pattern-version__option' + (isActive ? ' is-active' : '') + '"'
          + ' data-version-idx="' + idx + '"'
          + ' aria-pressed="' + String(isActive) + '">'
          + escHtml(v.label)
          + '</button>';
      }).join('');

      host.innerHTML = '<span class="pattern-version__label">' + escHtml(i18n.versionLabel || '') + '</span>'
        + '<div class="pattern-version__options" role="group" aria-label="' + escHtml(i18n.versionLabel || '') + '">'
        + optionsHtml
        + '</div>';

      host.querySelectorAll('.pattern-version__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.dataset.versionIdx);
          if (isNaN(idx) || !versions[idx] || versions[idx].id === activeVersion.id) return;
          // Remember this version's current picks before leaving it, so
          // switching back later restores them instead of re-defaulting.
          if (yarnPickers.length) versionPickerCache[activeVersion.id] = yarnPickers;

          activeVersion = versions[idx];
          host.querySelectorAll('.pattern-version__option').forEach(function (b) {
            var on = (parseInt(b.dataset.versionIdx) === idx);
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', String(on));
          });
          // Restore any custom edits already made on this version; otherwise
          // start from an empty slate so renderYarnSection falls back to the
          // new version's own recommended colorways instead of the old one's.
          yarnPickers = versionPickerCache[activeVersion.id] || [];
          if (currentSizeName) renderYarnSection(currentSizeName);
          updateBundleButton();
        });
      });
    }

    // ── Yarn section rendering ───────────────────────────────────────────────
    function renderYarnSection(sizeName) {
      var yarnSection = document.getElementById('pattern-yarn-section-' + sid);
      if (!yarnSection) return;

      var sizeYarns = activeVersion.sizes[sizeName];
      if (!sizeYarns || !sizeYarns.length) {
        yarnSection.innerHTML = '';
        yarnPickers = [];
        updateBundleButton();
        return;
      }

      // Preserve any colorway/inclusion choice the customer already made for a
      // yarn slot (matched by role + handle) so switching size doesn't wipe it.
      var previousPickers = {};
      yarnPickers.forEach(function (picker) {
        previousPickers[picker.role + '|' + picker.handle] = picker;
      });

      yarnPickers = sizeYarns.map(function (yarn) {
        var prev = previousPickers[(yarn.role || '') + '|' + yarn.handle];
        // A recommended colour that can no longer be bought (e.g. discontinued
        // and sold out) is neither pre-selected nor offered by the reset link.
        var recommended = yarn.variants.find(function (v) { return v.id === yarn.variant_id; });
        var recommendedId = recommended && recommended.available ? recommended.id : null;
        return {
          handle: yarn.handle,
          title: yarn.title,
          url: yarn.url,
          role: yarn.role || '',
          quantity: yarn.quantity,
          minQuantity: yarnRequired ? yarn.quantity : 1,
          variants: yarn.variants,
          selectedVariantId: prev ? prev.selectedVariantId : recommendedId,
          recommendedVariantId: recommendedId,
          included: prev ? prev.included : true
        };
      });

      var html = '<h2 class="pattern-yarn__heading">' + escHtml(i18n.yarnHeading || '') + '</h2>';
      if (yarnRequired && i18n.yarnRequiredNote) {
        html += '<p class="pattern-yarn__note">' + escHtml(i18n.yarnRequiredNote) + '</p>';
      }
      if (i18n.chooseHint) {
        html += '<p class="pattern-yarn__hint">'
          + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">'
          + '<path d="M5.5 2.5 11 7l-2.4.7 1.5 2.6-1.4.8-1.5-2.6L5.5 10z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>'
          + '</svg>'
          + '<span>' + escHtml(i18n.chooseHint) + '</span>'
          + '</p>';
      }
      html += yarnPickers.map(function (picker, idx) {
        return buildPickerHtml(picker, idx);
      }).join('');

      // Reset link: only meaningful when at least one picker has a recommended
      // colorway. Hidden until the customer deviates from it (see updateResetState).
      var hasRecommended = yarnPickers.some(function (p) { return p.recommendedVariantId != null; });
      if (hasRecommended && i18n.resetColors) {
        html += '<button type="button" class="pattern-yarn__reset" hidden>'
          + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">'
          + '<path d="M2 7a5 5 0 1 1 1.5 3.5M2 7V4M2 7h3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>'
          + '</svg>'
          + '<span>' + escHtml(i18n.resetColors) + '</span>'
          + '</button>';
      }

      yarnSection.innerHTML = html;
      initYarnPickers(yarnSection);
      updateBundleButton();
      updateResetState(yarnSection);
    }

    // Restore every picker to its recommended colorway by replaying a click on
    // the matching swatch (reuses all the selection/DOM-update logic).
    function resetToRecommended(yarnSection) {
      yarnPickers.forEach(function (picker, idx) {
        if (picker.recommendedVariantId == null) return;
        if (picker.selectedVariantId === picker.recommendedVariantId) return;
        var pickerEl = yarnSection.querySelector('.yarn-picker[data-picker-idx="' + idx + '"]');
        if (!pickerEl) return;
        var swatch = pickerEl.querySelector('.color-list__item[data-variant-id="' + picker.recommendedVariantId + '"]');
        if (swatch) swatch.click();
      });
    }

    // Show the reset link only when a selection differs from the recommendation.
    function updateResetState(yarnSection) {
      var resetBtn = yarnSection.querySelector('.pattern-yarn__reset');
      if (!resetBtn) return;
      var deviates = yarnPickers.some(function (p) {
        return p.recommendedVariantId != null && p.selectedVariantId !== p.recommendedVariantId;
      });
      resetBtn.hidden = !deviates;
    }

    // "(Utgående)" while a discontinued colour is in stock, "(Utgått)" once gone.
    function discontinuedLabel(v) {
      if (!v || !v.discontinued) return '';
      return (v.available ? i18n.discontinuedLabel : i18n.discontinuedGoneLabel) || '';
    }

    // The label after a colour's name: discontinued state, else its special label
    // ("(Limited Edition)", kept when sold out since it won't be restocked), else
    // "(Beställningsvara)" when out of stock but still sold, else "(Tillfälligt slut)".
    function colorLabel(v) {
      if (!v) return '';
      if (v.discontinued) return discontinuedLabel(v);
      if (v.special_label) return '(' + v.special_label + ')';
      if (v.backorder) return i18n.backorder ? '(' + i18n.backorder + ')' : '';
      return !v.available && i18n.soldOut ? '(' + i18n.soldOut + ')' : '';
    }

    // Colour title as shown in a picker's status line, with any label.
    function statusTitle(v) {
      var label = colorLabel(v);
      return label ? v.title + ' ' + label : v.title;
    }

    function buildPickerHtml(picker, idx) {
      var preSelected = picker.selectedVariantId
        ? picker.variants.find(function (v) { return v.id === picker.selectedVariantId; })
        : null;

      var colorListHtml = picker.variants.map(function (v) {
        var isActive = (v.id === picker.selectedVariantId);
        var titleParts = v.title.split(' ');
        var colorCode = escHtml(titleParts[0] || '');
        var colorName = escHtml(titleParts.slice(1).join(' ').replace(/^[-–]\s*/, '') || v.title);
        var unavailClass = v.available ? '' : ' is-unavailable';
        var activeClass = isActive ? ' is-active' : '';
        var flag = colorLabel(v);
        var isSpecial = !v.discontinued && !!v.special_label;
        var flagClass = (v.discontinued ? ' has-discontinued' : '') + (isSpecial ? ' has-special' : '') + (v.backorder ? ' has-backorder' : '');
        var swatchEl = v.color_hex
          ? '<span class="color-list__swatch" style="background:' + v.color_hex + ';"></span>'
          : '<span class="color-list__swatch color-list__swatch--empty"></span>';
        return '<button type="button"'
          + ' class="color-list__item' + unavailClass + activeClass + flagClass + '"'
          + ' data-variant-id="' + v.id + '"'
          + ' data-image-url="' + escHtml(v.image_url || '') + '"'
          + ' data-color-hex="' + escHtml(v.color_hex || '') + '"'
          + ' data-variant-title="' + escHtml(v.title) + '"'
          + ' data-status-title="' + escHtml(statusTitle(v)) + '"'
          + ' data-picker-idx="' + idx + '"'
          + ' aria-label="' + escHtml(statusTitle(v)) + '"'
          + (v.available ? '' : ' aria-disabled="true"')
          + ' role="option"'
          + ' aria-selected="' + String(isActive) + '">'
          + swatchEl
          + '<span class="color-list__code">' + colorCode + '</span>'
          + '<span class="color-list__name">' + colorName + '</span>'
          + (flag ? '<span class="color-list__flag' + (v.discontinued ? '' : isSpecial ? ' color-list__flag--special' : v.backorder ? ' color-list__flag--backorder' : ' color-list__flag--soldout') + '">' + escHtml(flag) + '</span>' : '')
          + '<svg class="color-list__check" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.5 7l3.5 3.5 5.5-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          + '</button>';
      }).join('');

      // Optional yarns (non-Sandnes) get an include checkbox; required yarns don't.
      var includeHtml = yarnRequired ? ''
        : '<label class="yarn-picker__include-label" title="' + escHtml(i18n.includeYarn || '') + '">'
          + '<input type="checkbox" class="yarn-picker__include" data-picker-idx="' + idx + '" checked'
          + ' aria-label="' + escHtml(i18n.includeYarn || '') + '">'
          + '</label>';

      var titleName = '<span class="yarn-picker__title-name">' + escHtml(picker.title) + '</span>';
      var titleHtml = picker.role
        ? '<span class="yarn-picker__role">' + escHtml(roleLabel(picker.role)) + '</span>' + titleName
        : titleName;

      var hasSelected = !!preSelected;
      var thumbHtml = buildThumbHtml(preSelected);
      var statusClass = hasSelected ? 'yarn-picker__status' : 'yarn-picker__status yarn-picker__status--empty';
      var statusText = hasSelected ? escHtml(statusTitle(preSelected)) : escHtml(i18n.chooseColorPrompt || '');
      var qtyHidden = hasSelected ? '' : ' hidden';

      return '<div class="yarn-picker" data-picker-idx="' + idx + '">'
        // Compact head row: [include?] thumb · title/status · qty · chevron.
        // The whole row toggles the color list (delegated handler ignores the
        // checkbox, qty stepper and title link so those keep their own behaviour).
        + '<div class="yarn-picker__head" data-expand-picker="' + idx + '" role="button" tabindex="0" aria-expanded="false">'
        +   includeHtml
        +   '<span class="yarn-picker__thumb">' + thumbHtml + '</span>'
        +   '<span class="yarn-picker__info">'
        +     '<span class="yarn-picker__title">' + titleHtml + '</span>'
        +     '<span class="' + statusClass + '">' + statusText + '</span>'
        +   '</span>'
        +   '<span class="yarn-picker__actions">'
        +   '<span class="yarn-picker__qty"' + qtyHidden + '>'
        +     '<span class="yarn-picker__qty-unit">' + escHtml(i18n.yarnUnit || '') + '</span>'
        +     '<div class="product-form__qty">'
        +       '<button type="button" class="product-form__qty-btn" data-qty-action="dec" data-picker-idx="' + idx + '" aria-label="' + escHtml(i18n.decreaseQuantity || '–') + '"' + (picker.quantity <= picker.minQuantity ? ' disabled' : '') + '>'
        +         '<svg width="12" height="2" viewBox="0 0 12 2" fill="none" aria-hidden="true"><path d="M1 1h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
        +       '</button>'
        +       '<input type="number" class="product-form__qty-input yarn-qty-input" value="' + picker.quantity + '" min="' + picker.minQuantity + '" data-picker-idx="' + idx + '">'
        +       '<button type="button" class="product-form__qty-btn" data-qty-action="inc" data-picker-idx="' + idx + '" aria-label="' + escHtml(i18n.increaseQuantity || '+') + '">'
        +         '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
        +       '</button>'
        +     '</div>'
        +   '</span>'
        +   '<span class="yarn-picker__price"' + qtyHidden + '>'
        +     (hasSelected ? formatMoney(preSelected.price) : '')
        +   '</span>'
        +   '</span>'
        +   '<svg class="yarn-picker__expand-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</div>'
        // Color picker: hidden by default, expands inside the card
        + '<div class="yarn-color-picker" hidden>'
        +   '<div class="yarn-color-picker__controls">'
        +     '<input type="search" class="yarn-color-picker__search yarn-swatch-search"'
        +       ' placeholder="' + escHtml(i18n.searchColors || '') + '"'
        +       ' autocomplete="off" spellcheck="false">'
        +     '<label class="yarn-color-picker__filter-stock">'
        +       '<input type="checkbox" class="yarn-swatch-filter-instock"> '
        +       escHtml(i18n.filterInstock || '')
        +     '</label>'
        +   '</div>'
        +   '<div class="color-list" role="listbox" aria-label="' + escHtml(picker.title) + '">'
        +     colorListHtml
        +   '</div>'
        + '</div>'
        + '</div>';
    }

    // Thumbnail markup for the compact head: image if the colorway has one,
    // else a flat swatch from its hex, else an empty placeholder.
    function buildThumbHtml(variant) {
      if (variant && variant.image_url) {
        return '<img class="yarn-picker__thumb-img" src="' + escHtml(variant.image_url)
          + '" alt="' + escHtml(variant.title) + '" width="44" height="44" loading="lazy">';
      }
      if (variant && variant.color_hex) {
        return '<span class="yarn-picker__thumb-swatch" style="background:' + escHtml(variant.color_hex) + ';"></span>';
      }
      return '<span class="yarn-picker__thumb-swatch yarn-picker__thumb-swatch--empty"></span>';
    }

    function initYarnPickers(yarnSection) {
      // Delegated listeners live on yarnSection itself, which survives the
      // innerHTML replacement on every re-render. Bind them only once,
      // otherwise each render stacks another copy and clicks fire N times
      // (e.g. the + stepper would increment by more than one).
      if (!yarnSection.dataset.delegatesBound) {
        yarnSection.dataset.delegatesBound = 'true';
        bindYarnSectionDelegates(yarnSection);
      }

      // Color search + stock filter
      yarnSection.querySelectorAll('.yarn-swatch-search').forEach(function (input) {
        var pickerDiv = input.closest('.yarn-color-picker');
        if (!pickerDiv) return;
        var colorList = pickerDiv.querySelector('.color-list');
        var stockCb = pickerDiv.querySelector('.yarn-swatch-filter-instock');

        function applyFilter() {
          var q = input.value.trim().toLowerCase();
          var onlyStock = stockCb && stockCb.checked;
          colorList.querySelectorAll('.color-list__item').forEach(function (item) {
            var matchSearch = !q || (item.dataset.variantTitle || '').toLowerCase().includes(q);
            // "In stock" means on the shelf: hides backorder colours too, as on the yarn page
            var matchStock = !onlyStock || (!item.classList.contains('is-unavailable') && !item.classList.contains('has-backorder'));
            item.hidden = !(matchSearch && matchStock);
          });
        }

        input.addEventListener('input', applyFilter);
        if (stockCb) stockCb.addEventListener('change', applyFilter);
      });

      yarnSection.querySelectorAll('.yarn-qty-input').forEach(function (input) {
        input.addEventListener('change', function () {
          var pickerIdx = parseInt(input.dataset.pickerIdx);
          var picker = yarnPickers[pickerIdx];
          var min = picker ? picker.minQuantity : 1;
          var val = Math.max(min, parseInt(input.value) || min);
          input.value = val;
          if (picker) picker.quantity = val;
          updateDecState(yarnSection, pickerIdx, val, min);
          updateBundleButton();
        });
      });

      // Include yarn checkbox (non-Sandnes only)
      yarnSection.querySelectorAll('.yarn-picker__include').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var pickerIdx = parseInt(cb.dataset.pickerIdx);
          if (yarnPickers[pickerIdx]) yarnPickers[pickerIdx].included = cb.checked;
          var pickerEl = yarnSection.querySelector('.yarn-picker[data-picker-idx="' + pickerIdx + '"]');
          if (pickerEl) pickerEl.classList.toggle('yarn-picker--excluded', !cb.checked);
          updateBundleButton();
        });
      });
    }

    // Grey out the "–" button when the picker is at its minimum quantity.
    function updateDecState(yarnSection, pickerIdx, value, min) {
      var decBtn = yarnSection.querySelector(
        '.product-form__qty-btn[data-qty-action="dec"][data-picker-idx="' + pickerIdx + '"]'
      );
      if (decBtn) decBtn.disabled = value <= min;
    }

    // Refresh a single picker's line price (selected variant × quantity).
    function updatePickerPrice(yarnSection, pickerIdx) {
      var picker = yarnPickers[pickerIdx];
      if (!picker) return;
      var pickerEl = yarnSection.querySelector('.yarn-picker[data-picker-idx="' + pickerIdx + '"]');
      if (!pickerEl) return;
      var priceEl = pickerEl.querySelector('.yarn-picker__price');
      if (!priceEl) return;
      if (picker.selectedVariantId == null) {
        priceEl.hidden = true;
        priceEl.textContent = '';
        return;
      }
      var v = picker.variants.find(function (vv) { return vv.id === picker.selectedVariantId; });
      priceEl.hidden = false;
      priceEl.textContent = v ? formatMoney(v.price) : '';
    }

    // Expand / collapse a picker's color list. `head` is its .yarn-picker__head.
    function togglePickerExpand(yarnSection, head) {
      var pickerIdx = parseInt(head.dataset.expandPicker);
      var pickerEl = yarnSection.querySelector('.yarn-picker[data-picker-idx="' + pickerIdx + '"]');
      if (!pickerEl) return;
      var colorPicker = pickerEl.querySelector('.yarn-color-picker');
      if (!colorPicker) return;
      var isExpanded = !colorPicker.hidden;
      colorPicker.hidden = isExpanded;
      head.setAttribute('aria-expanded', String(!isExpanded));
      var icon = head.querySelector('.yarn-picker__expand-icon');
      if (icon) icon.classList.toggle('is-expanded', !isExpanded);
      if (!isExpanded) {
        var activeItem = colorPicker.querySelector('.color-list__item.is-active');
        if (activeItem) setTimeout(function () { activeItem.scrollIntoView({ block: 'nearest' }); }, 50);
      }
    }

    function bindYarnSectionDelegates(yarnSection) {
      // Expand / collapse toggle — the whole head row is clickable, but clicks
      // on the include checkbox, qty stepper or title link keep their own
      // behaviour rather than toggling the list.
      yarnSection.addEventListener('click', function (e) {
        var head = e.target.closest('.yarn-picker__head');
        if (!head) return;
        if (e.target.closest('.yarn-picker__qty')) return;
        if (e.target.closest('.yarn-picker__include-label')) return;
        togglePickerExpand(yarnSection, head);
      });

      // Keyboard: the head has role="button", so Enter/Space toggle it.
      yarnSection.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var head = e.target.closest('.yarn-picker__head');
        if (!head || head !== e.target) return;
        e.preventDefault();
        togglePickerExpand(yarnSection, head);
      });

      // Color list clicks
      yarnSection.addEventListener('click', function (e) {
        var swatch = e.target.closest('.color-list__item');
        if (!swatch) return;
        // Sold-out colours can't be added to the cart, so they can't be picked
        if (swatch.classList.contains('is-unavailable')) return;
        var pickerIdx = parseInt(swatch.dataset.pickerIdx);
        var variantId = parseInt(swatch.dataset.variantId);
        if (isNaN(pickerIdx) || isNaN(variantId)) return;

        var picker = yarnPickers[pickerIdx];
        if (!picker) return;
        picker.selectedVariantId = variantId;

        var pickerEl = yarnSection.querySelector('.yarn-picker[data-picker-idx="' + pickerIdx + '"]');
        if (pickerEl) {
          pickerEl.querySelectorAll('.color-list__item').forEach(function (sw) {
            var active = parseInt(sw.dataset.variantId) === variantId;
            sw.classList.toggle('is-active', active);
            sw.setAttribute('aria-selected', String(active));
          });

          // Update the compact head: thumbnail, status line, reveal qty.
          var head = pickerEl.querySelector('.yarn-picker__head');
          var thumb = pickerEl.querySelector('.yarn-picker__thumb');
          var statusEl = pickerEl.querySelector('.yarn-picker__status');
          var qtyEl = pickerEl.querySelector('.yarn-picker__qty');

          var variantTitle = swatch.dataset.variantTitle || '';
          var imageUrl = swatch.dataset.imageUrl || '';
          var colorHex = swatch.dataset.colorHex || '';

          if (statusEl) {
            statusEl.textContent = swatch.dataset.statusTitle || variantTitle;
            statusEl.classList.remove('yarn-picker__status--empty');
          }

          if (thumb) {
            while (thumb.firstChild) thumb.removeChild(thumb.firstChild);
            if (imageUrl) {
              var im = document.createElement('img');
              im.className = 'yarn-picker__thumb-img';
              im.src = imageUrl;
              im.alt = variantTitle;
              im.width = 44;
              im.height = 44;
              im.loading = 'lazy';
              thumb.appendChild(im);
            } else {
              var sp = document.createElement('span');
              sp.className = 'yarn-picker__thumb-swatch' + (colorHex ? '' : ' yarn-picker__thumb-swatch--empty');
              if (colorHex) sp.style.background = colorHex;
              thumb.appendChild(sp);
            }
          }
          if (qtyEl) qtyEl.hidden = false;
          updatePickerPrice(yarnSection, pickerIdx);

          // Auto-collapse color picker after selection
          var colorPickerEl = pickerEl.querySelector('.yarn-color-picker');
          if (colorPickerEl) colorPickerEl.hidden = true;
          if (head) {
            head.setAttribute('aria-expanded', 'false');
            var icon = head.querySelector('.yarn-picker__expand-icon');
            if (icon) icon.classList.remove('is-expanded');
          }
        }

        updateBundleButton();
        updateResetState(yarnSection);
      });

      // Reset all pickers back to the pattern's recommended colors
      yarnSection.addEventListener('click', function (e) {
        var resetBtn = e.target.closest('.pattern-yarn__reset');
        if (!resetBtn) return;
        resetToRecommended(yarnSection);
        updateResetState(yarnSection);
      });

      // Quantity steppers
      yarnSection.addEventListener('click', function (e) {
        var btn = e.target.closest('.product-form__qty-btn');
        if (!btn) return;
        var pickerIdx = parseInt(btn.dataset.pickerIdx);
        var qtyInput = yarnSection.querySelector('.yarn-qty-input[data-picker-idx="' + pickerIdx + '"]');
        if (!qtyInput) return;
        var picker = yarnPickers[pickerIdx];
        var min = picker ? picker.minQuantity : 1;
        var current = parseInt(qtyInput.value) || min;
        if (btn.dataset.qtyAction === 'inc') {
          qtyInput.value = current + 1;
          if (picker) picker.quantity = current + 1;
        } else if (btn.dataset.qtyAction === 'dec' && current > min) {
          qtyInput.value = current - 1;
          if (picker) picker.quantity = current - 1;
        }
        updateDecState(yarnSection, pickerIdx, parseInt(qtyInput.value) || min, min);
        updateBundleButton();
      });
    }

    // ── Listen for variant changes from product-form.liquid ──────────────────
    container.addEventListener('product:variant-changed', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      var sizeName = sizeKey(variant);
      if (sizeName) {
        currentSizeName = sizeName;
        renderYarnSection(sizeName);
      }
      updateBundleButton();
    });

    // ── Add all to cart ──────────────────────────────────────────────────────
    var atcBtn = document.getElementById('pattern-atc-' + sid);
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;

        var variantInput = document.getElementById('variant-id-' + sid);
        var patternVariantId = variantInput ? parseInt(variantInput.value) : null;
        if (!patternVariantId) return;

        var items = [{ id: patternVariantId, quantity: 1 }];
        yarnPickers.forEach(function (picker) {
          if (picker.included && picker.selectedVariantId) {
            items.push({ id: picker.selectedVariantId, quantity: picker.quantity });
          }
        });

        // Link pattern + yarn lines with a shared bundle id so the cart can
        // cascade-remove the pair and lock their quantities. Unique per
        // "add all" click so two bundles in one cart stay independent.
        if (items.length > 1) {
          var bundleId = 'pattern-' + patternVariantId + '-' + Date.now();
          items.forEach(function (i) {
            i.properties = { _bundle_id: bundleId };
          });
        }

        atcBtn.disabled = true;
        atcBtn.classList.add('product-form__atc--loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw d; });
            return res.json();
          })
          .then(function (data) {
            atcBtn.classList.remove('product-form__atc--loading');
            updateBundleButton();

            var addedItems = data.items || [];
            var firstItem = addedItems[0] || {};
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: {
                title: firstItem.product_title || '',
                subtitle: items.length > 1
                  ? ('+ ' + (items.length - 1) + ' garner')
                  : (firstItem.variant_title || ''),
                quantity: items.reduce(function (s, i) { return s + i.quantity; }, 0)
              }
            }));

            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (res) { return res.json(); })
          .then(function (cartData) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { count: cartData.item_count }
            }));
          })
          .catch(function () {
            atcBtn.classList.remove('product-form__atc--loading');
            updateBundleButton();
          });
      });
    }

    // ── Initial render (page loaded with a pre-selected variant) ─────────────
    renderVersionSelector();

    var variantInput = document.getElementById('variant-id-' + sid);
    if (variantInput && variantInput.value) {
      var productDataEl = document.getElementById('product-json-' + sid);
      if (productDataEl) {
        var productData = JSON.parse(productDataEl.textContent);
        var initialVariant = productData.variants.find(function (v) {
          return String(v.id) === variantInput.value;
        });
        if (initialVariant && sizeKey(initialVariant)) {
          currentSizeName = sizeKey(initialVariant);
          renderYarnSection(currentSizeName);
        }
      }
    }

    updateBundleButton();
    } // end initPatternPage
  })();

  // ── Pattern spec sheet (legacy rich-text path) ──────────────────────────────
  // Splits the rich-text "Om mönstret" metafield into sections (one per <h2>).
  // Short single-paragraph sections become rows in the key/value spec list;
  // everything with lists or longer prose becomes a detail block. Mirrors the
  // server-rendered structured layout. Wrapped defensively so a content quirk
  // can never break the purchase flow above.
  (function () {
    document.querySelectorAll('[id^="pattern-details-source-"]').forEach(function (source) {
      try {
        buildSpecSheet(source);
      } catch (e) {
        // Fall back to showing the raw rich text rather than nothing.
        source.hidden = false;
      }
    });

    function buildSpecSheet(source) {
      var sid = source.id.replace('pattern-details-source-', '');
      var grid = document.getElementById('pattern-details-grid-' + sid);
      if (!grid) return;

      var root = source.firstElementChild || source;
      var nodes = Array.prototype.slice.call(root.children);
      if (!nodes.length) { source.remove(); return; }

      // Group flat rich-text nodes into sections that each start at an <h2>.
      var sections = [];
      var current = null;
      nodes.forEach(function (node) {
        if (node.tagName === 'H2') {
          current = { title: node.textContent.trim(), body: [] };
          sections.push(current);
        } else {
          if (!current) {
            current = { title: '', body: [] };
            sections.push(current);
          }
          current.body.push(node);
        }
      });

      // Short single-paragraph sections become rows in the key/value spec
      // list; everything with lists or longer prose becomes a detail block.
      var specsList = document.createElement('dl');
      specsList.className = 'spec-sheet__specs';
      var blocksHost = document.createElement('div');
      blocksHost.className = 'spec-sheet__cards';

      sections.forEach(function (sec) {
        var bodyText = sec.body.map(function (n) { return n.textContent; }).join(' ').replace(/\s+/g, ' ').trim();
        var isSpec = sec.title
          && sec.body.length === 1
          && sec.body[0].tagName === 'P'
          && bodyText.length <= 90;

        if (isSpec) {
          var row = document.createElement('div');
          row.className = 'spec-row';

          var rdt = document.createElement('dt');
          rdt.className = 'spec-row__label';
          rdt.textContent = sec.title;

          var rdd = document.createElement('dd');
          rdd.className = 'spec-row__value';
          rdd.textContent = bodyText;

          row.appendChild(rdt);
          row.appendChild(rdd);
          specsList.appendChild(row);
          return;
        }

        var card = document.createElement('div');
        card.className = 'spec-card';

        if (sec.title) {
          var h = document.createElement('h3');
          h.className = 'spec-card__title';
          h.textContent = sec.title;
          card.appendChild(h);
        }

        var body = document.createElement('div');
        body.className = 'spec-card__body rte';
        sec.body.forEach(function (n) { body.appendChild(n); });
        card.appendChild(body);

        blocksHost.appendChild(card);
      });

      if (specsList.children.length) grid.appendChild(specsList);
      if (blocksHost.children.length) grid.appendChild(blocksHost);

      source.remove();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    const sectionId = document.currentScript
      ? document.currentScript.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '')
      : null;
    if (!sectionId) return;

    const recsEl = document.getElementById('product-recommendations-' + sectionId);
    if (recsEl && recsEl.dataset.url) {
      fetch(recsEl.dataset.url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.getElementById('product-recommendations-' + sectionId);
          if (inner && inner.innerHTML.trim()) {
            recsEl.innerHTML = inner.innerHTML;
          }
        })
        .catch(function () { /* recommendations unavailable */ });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
